import { Controller } from "@hotwired/stimulus"

// Auto-saves a form via PATCH every N ms after the last input change.
// Values:
//   - url (String) — endpoint to PATCH
//   - debounce (Number, default 2000) — ms to wait after last input
// Targets:
//   - status (Element) — text node updated with last-saved time
export default class extends Controller {
  static values = { url: String, debounce: { type: Number, default: 2000 } }
  static targets = ["status"]

  connect() {
    this._timer = null
    this._lastSave = null
    this._tickInterval = setInterval(() => this.#renderTick(), 1000)
    this.element.addEventListener("input", () => this.#schedule())
    this.element.addEventListener("change", () => this.#schedule())
  }

  disconnect() {
    clearTimeout(this._timer)
    clearInterval(this._tickInterval)
  }

  #schedule() {
    clearTimeout(this._timer)
    this._timer = setTimeout(() => this.save(), this.debounceValue)
  }

  async save() {
    const formData = new FormData(this.element)
    formData.set("_method", "patch")
    const csrf = document.querySelector('meta[name="csrf-token"]')?.content
    try {
      const res = await fetch(this.urlValue, {
        method: "POST",
        headers: { "X-CSRF-Token": csrf, "Accept": "text/vnd.turbo-stream.html" },
        body: formData
      })
      if (res.ok) {
        this._lastSave = Date.now()
        this.#renderTick()
        const text = await res.text()
        if (text && window.Turbo) window.Turbo.renderStreamMessage(text)
      }
    } catch (_) {
      // Silent fail; user can still hit Publier manually.
    }
  }

  #renderTick() {
    if (!this.hasStatusTarget || !this._lastSave) return
    const seconds = Math.floor((Date.now() - this._lastSave) / 1000)
    let label
    if (seconds < 5) label = "Brouillon enregistré à l'instant"
    else if (seconds < 60) label = `Brouillon enregistré il y a ${seconds} s`
    else label = `Brouillon enregistré il y a ${Math.floor(seconds / 60)} min`
    this.statusTarget.textContent = label
  }
}
